import { sharedSchema } from "@shared-database/pgSchema";
import { File } from "@shared-database/schema";
import {
  leoID,
  leoNotNullForeignID,
  timestampColumns,
} from "@shared-database/utils";
import { type InferSelectModel } from "drizzle-orm";
import { index } from "drizzle-orm/pg-core";

export const PreviewFile = sharedSchema.table(
  "PreviewFile",
  {
    // Mixins
    ...timestampColumns,

    // References
    fileId: leoNotNullForeignID("fileId").references(() => File.id, {
      onDelete: "cascade",
    }),
    parentFileId: leoNotNullForeignID("parentFileId").references(
      () => File.id,
      {
        onDelete: "cascade",
      },
    ),

    // Properties
    id: leoID("id"),
  },
  (table) => [
    index("PreviewFile_fileIdIdx").on(table.fileId),
    index("PreviewFile_parentFileIdIdx").on(table.parentFileId),
  ],
);

// Types & Schemas
export type PreviewFileType = InferSelectModel<typeof PreviewFile>;
